// Route error boundary (DESIGN_SPEC §10.15): an ink .alert with what failed and a way out, never red.
// Inside the shell when a page throws while rendering; `bare` (no nav or footer) when the shell itself fails.
//   <RouteError bare? />
import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Alert, Kicker } from "@/components/ui";
import { Atmosphere } from "./Atmosphere";

function describe(err: unknown): string {
  if (isRouteErrorResponse(err)) return `${err.status} ${err.statusText}`.trim();
  if (err instanceof Error) return err.message || err.name;
  return String(err ?? "unknown error");
}

export function RouteError({ bare }: { bare?: boolean }) {
  const err = useRouteError();
  const body = (
    <div className="page">
      <div className="mx-auto grid max-w-measure gap-5 py-16">
        <Kicker>malbox · error</Kicker>
        <h1 className="page-title mt-0 max-w-none">This view failed to draw.</h1>
        <Alert
          head="Rendering failed"
          actions={
            <>
              <button type="button" className="lnk" onClick={() => window.location.reload()}>
                Reload
              </button>
              {bare ? (
                <a className="lnk" href="/jobs">
                  All analyses
                </a>
              ) : (
                <Link className="lnk" to="/jobs">
                  All analyses
                </Link>
              )}
            </>
          }
        >
          <span translate="no">{describe(err)}</span>
        </Alert>
        {!bare && <p className="note">The rest of malbox still works; the error is in this view only.</p>}
      </div>
    </div>
  );
  if (!bare) return body;
  return (
    <>
      <Atmosphere />
      <main id="main">{body}</main>
    </>
  );
}
